export default "__VITE_ASSET__0adf0f34__"